/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import ErrorContentInfo from 'DesignSystem/ErrorContentInfo/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Content/Home/AccountBalance/Content/Error"
  
}) {
  return (<React.Fragment
>
<ErrorContentInfo
  viewPath={`${viewPath}/ErrorContentInfo`}
/>
{children}
</React.Fragment>)
}